/* LUME spectrum waves (updated 19 Oct 2026 for speed: lighter resolution on phones, about 30 frames a second,
   and the glow is drawn as a faint wide line instead of a costly blur) */
(() => {
  const KEYS = [
    { rgb: '201,63,46', color: '#C93F2E', lambda: 644, cap: 'Red Spectrum · Joint Relief' },
    { rgb: '63,143,92', color: '#3F8F5C', lambda: 538, cap: 'Green Spectrum · Muscle Ease' },
    { rgb: '216,155,43', color: '#D89B2B', lambda: 580, cap: 'Amber Spectrum · Hypo Thyra' },
    { rgb: '61,95,168', color: '#3D5FA8', lambda: 453.5, cap: 'Blue Spectrum · Mind Calm' },
  ];

  const num = document.getElementById('specNum');
  const cap = document.getElementById('specCap');
  const legend = document.getElementById('specLegend');
  const hero = document.getElementById('specHero');
  const sec = document.getElementById('science');
  const titleEms = document.querySelectorAll('.spectrum .spec-title em');

  let active = 0;

  // Fill in any legend swatch colour the theme settings left blank
  legend?.querySelectorAll('button').forEach((btn, idx) => {
    if (!btn.style.getPropertyValue('--sc').trim() && KEYS[idx]) {
      btn.style.setProperty('--sc', KEYS[idx].color);
    }
  });

  // Inline !important beats any theme CSS. -webkit-text-fill-color is needed
  // in case the big number is gradient-clipped text, where `color` does nothing.
  const paint = (el, c) => {
    if (!el) return;
    el.style.setProperty('color', c, 'important');
    el.style.setProperty('-webkit-text-fill-color', c, 'important');
    el.style.setProperty('background-image', 'none', 'important');
  };

  const setActive = (i) => {
    active = i;
    const p = KEYS[active];

    if (num) {
      while (num.firstChild) num.removeChild(num.firstChild);
      num.appendChild(document.createTextNode(String(p.lambda)));
      const sup = document.createElement('sup');
      sup.textContent = 'nm';
      num.appendChild(sup);
      paint(num, p.color);
      paint(sup, p.color);   // remove this line to keep "nm" grey
    }

    if (cap) {
      cap.textContent = p.cap;
      paint(cap, p.color);   // remove this line to keep the caption green
    }

    // "motion" in the spectrum heading
    titleEms.forEach((el) => paint(el, p.color));

    hero?.style.setProperty('--spec-color', p.color);
    sec?.style.setProperty('--spec-color', p.color);

    legend?.querySelectorAll('button').forEach((btn, idx) => {
      btn.classList.toggle('active', idx === active);
    });
  };

  legend?.querySelectorAll('button').forEach((btn, idx) => {
    btn.addEventListener('click', () => setActive(idx));
  });

  setActive(0);

  // ---- Animated canvas below; the colour above works with or without it ----

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.dataset.lumeAnim === 'off') return;

  const cv = document.getElementById('specCanvas');
  const spectrum = document.querySelector('.spectrum');
  if (!cv || !spectrum) return;
  const ctx = cv.getContext('2d');
  if (!ctx) return;

  let W = 0;
  let H = 0;
  let t = 0;
  let raf = 0;
  let last = 0;
  let visible = false;
  /* Lighter resolution on high-density phone screens; the lines still look sharp */
  const DPR = Math.min(window.devicePixelRatio || 1, 1.5);

  const size = () => {
    W = cv.width = Math.round(cv.offsetWidth * DPR);
    H = cv.height = Math.round(cv.offsetHeight * DPR);
  };

  const draw = (now) => {
    if (!visible) return;
    raf = requestAnimationFrame(draw);
    if (now && now - last < 33) return; // about 30 frames a second
    last = now || 0;
    ctx.clearRect(0, 0, W, H);
    KEYS.forEach((p, i) => {
      const act = i === active;
      const baseY = H * (0.2 + i * 0.2);
      const amp = H * 0.055 * (act ? 1.4 : 1);
      const cycles = 2200 / p.lambda;
      ctx.beginPath();
      for (let x = 0; x <= W; x += 4) {
        const y = baseY + Math.sin((x / W) * cycles * Math.PI * 2 - t * (1100 / p.lambda)) * amp;
        if (x === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      if (act) {
        /* soft glow: a wide faint line under the bright one (instead of the costly blur) */
        ctx.strokeStyle = `rgba(${p.rgb},.25)`;
        ctx.lineWidth = 7 * DPR;
        ctx.stroke();
      }
      ctx.strokeStyle = act ? p.color : `rgba(${p.rgb},.26)`;
      ctx.lineWidth = (act ? 1.8 : 0.9) * DPR;
      ctx.stroke();
    });
    t += 0.05;
  };

  size();
  addEventListener('resize', size);

  new IntersectionObserver(([e]) => {
    visible = e.isIntersecting;
    if (visible) {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(draw);
    }
  }, { threshold: 0.25 }).observe(spectrum);

  setInterval(() => {
    if (!visible) return;
    setActive((active + 1) % KEYS.length);
  }, 5000);
})();